
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBitIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 38,
  height: 21,
  viewBox: "0 0 38 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.208 3.668c0 .83-.684 1.505-1.528 1.505a1.517 1.517 0 0 1-1.528-1.505c0-.832.684-1.506 1.528-1.506s1.528.674 1.528 1.506z",
  fill: "#D32733"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.867 8.47v3.945c0 2.176 1.793 3.945 3.997 3.945 2.205 0 3.998-1.77 3.998-3.944 0-2.176-1.793-3.945-3.997-3.945H5.867zm3.998 10.587c-3.711 0-6.73-2.98-6.73-6.641V8.47H1.743A1.357 1.357 0 0 1 .377 7.122c0-.744.612-1.348 1.366-1.348h1.392v-3.92c0-.744.611-1.348 1.366-1.348.755 0 1.366.604 1.366 1.348v3.92h3.998c3.71 0 6.73 2.98 6.73 6.641 0 3.663-3.02 6.642-6.73 6.642zm8.781.033c-.75 0-1.358-.605-1.358-1.352V7.127c0-.747.608-1.352 1.358-1.352.75 0 1.358.605 1.358 1.352v10.611c0 .747-.608 1.352-1.358 1.352zm10.597-2.731c-2.194-.055-3.912-1.787-3.912-3.944V8.471h3.44a1.36 1.36 0 0 0 1.374-1.349 1.36 1.36 0 0 0-1.373-1.348H25.33v-3.92A1.36 1.36 0 0 0 23.958.506a1.36 1.36 0 0 0-1.373 1.348v3.92H22a1.36 1.36 0 0 0-1.373 1.348A1.36 1.36 0 0 0 22 8.471h.585v3.944c0 1.744.683 3.392 1.923 4.64a6.784 6.784 0 0 0 4.7 2c.743 0 1.354-.581 1.373-1.314a1.36 1.36 0 0 0-1.338-1.382z",
  fill: "#fff"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m31.778 20.464 5.66-3.117a.354.354 0 0 0-.052-.644l-6.09-2.19a.239.239 0 0 0-.287.103.238.238 0 0 0-.01.216l.878 2.016a.418.418 0 0 0 .365.25l2.503.108a.03.03 0 0 1 .029.028.03.03 0 0 1-.025.032l-2.453.5a.416.416 0 0 0-.32.303l-.542 2.127a.238.238 0 0 0 .044.212.24.24 0 0 0 .3.056z",
  fill: "#D32733"
})));

      const __svgRaw = "<svg width=\"38\" height=\"21\" viewBox=\"0 0 38 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.208 3.668c0 .83-.684 1.505-1.528 1.505a1.517 1.517 0 0 1-1.528-1.505c0-.832.684-1.506 1.528-1.506s1.528.674 1.528 1.506z\" fill=\"#D32733\"/>\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.867 8.47v3.945c0 2.176 1.793 3.945 3.997 3.945 2.205 0 3.998-1.77 3.998-3.944 0-2.176-1.793-3.945-3.997-3.945H5.867zm3.998 10.587c-3.711 0-6.73-2.98-6.73-6.641V8.47H1.743A1.357 1.357 0 0 1 .377 7.122c0-.744.612-1.348 1.366-1.348h1.392v-3.92c0-.744.611-1.348 1.366-1.348.755 0 1.366.604 1.366 1.348v3.92h3.998c3.71 0 6.73 2.98 6.73 6.641 0 3.663-3.02 6.642-6.73 6.642zM18.646 19.09c-.75 0-1.358-.605-1.358-1.352V7.127c0-.747.608-1.352 1.358-1.352.75 0 1.358.605 1.358 1.352v10.611c0 .747-.608 1.352-1.358 1.352zM29.243 16.359c-2.194-.055-3.912-1.787-3.912-3.944V8.471h3.44a1.36 1.36 0 0 0 1.374-1.349 1.36 1.36 0 0 0-1.373-1.348H25.33v-3.92A1.36 1.36 0 0 0 23.958.506a1.36 1.36 0 0 0-1.373 1.348v3.92H22a1.36 1.36 0 0 0-1.373 1.348A1.36 1.36 0 0 0 22 8.471h.585v3.944c0 1.744.683 3.392 1.923 4.64a6.784 6.784 0 0 0 4.7 2c.743 0 1.354-.581 1.373-1.314a1.36 1.36 0 0 0-1.338-1.382z\" fill=\"#fff\"/>\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m31.778 20.464 5.66-3.117a.354.354 0 0 0-.052-.644l-6.09-2.19a.239.239 0 0 0-.287.103.238.238 0 0 0-.01.216l.878 2.016a.418.418 0 0 0 .365.25l2.503.108a.03.03 0 0 1 .029.028.03.03 0 0 1-.025.032l-2.453.5a.416.416 0 0 0-.32.303l-.542 2.127a.238.238 0 0 0 .044.212.24.24 0 0 0 .3.056z\" fill=\"#D32733\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/bitIcon.f7aa8dda7970625852c84c00ee17a75c.svg"),
        {
          React: SvgBitIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      